import { render } from "./DesktopNavbarShadow.vue?vue&type=template&id=4979f146&scoped=true"
import script from "./DesktopNavbarShadow.vue?vue&type=script&lang=js"
export * from "./DesktopNavbarShadow.vue?vue&type=script&lang=js"

import "./DesktopNavbarShadow.vue?vue&type=style&index=0&id=4979f146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979f146"]])

export default __exports__